import { Type } from '@sinclair/typebox';
export var TokenModerationStatus;
(function (TokenModerationStatus) {
    TokenModerationStatus["Actve"] = "active";
    TokenModerationStatus["Restricted"] = "restricted";
    TokenModerationStatus["Processing"] = "processing";
})(TokenModerationStatus || (TokenModerationStatus = {}));
export var TokenModerationReason;
(function (TokenModerationReason) {
    TokenModerationReason["OpenAiFlagged"] = "openai_flagged";
    TokenModerationReason["GeminiFlagged"] = "gemini_flagged";
    TokenModerationReason["FetchFailed"] = "fetch_failed";
    TokenModerationReason["NoOnchainLogo"] = "no_onchain_logo";
    TokenModerationReason["S3NotFound"] = "s3_not_found";
})(TokenModerationReason || (TokenModerationReason = {}));
export const TokenModerationStatusSchema = Type.Enum(TokenModerationStatus);
export const TokenModerationReasonSchema = Type.Enum(TokenModerationReason);
//# sourceMappingURL=token-moderation.js.map